import MainLayout from '../components/layout/MainLayout';
import { SectionHome, LAST_TAB_PREFIX } from '../components/enterprise';
import { Building2, Users, ClipboardCheck, UserPlus } from 'lucide-react';

const getLastTab = (section) => {
  try {
    const raw = localStorage.getItem(`${LAST_TAB_PREFIX}${section}`);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
};

const OrganisatieHomePage = () => {
  const lastTab = getLastTab('organisatie');

  return (
    <MainLayout>
      <SectionHome
        question="Wat wil je binnen je organisatie regelen?"
        subtitle="Kies wat je wilt bereiken."
        resume={lastTab ? { title: lastTab.label, href: lastTab.href } : undefined}
        recommended={{
          title: 'Controleer bedrijfsgegevens',
          description: 'Vul gegevens aan voor betere analyses en rapportages. Ontbrekende sector- en contactinformatie beperkt de relevantie van dreigingen en benchmarks.',
          href: '/organisatie/gegevens',
          icon: Building2,
        }}
        alternatives={[
          {
            title: 'Beheer contactpersonen',
            description: 'Voeg personen toe en wijs ze toe als risico-eigenaar, incidentcontact of leverancierscontact.',
            href: '/organisatie/mensen',
            icon: Users,
          },
          {
            title: 'Verdeel verantwoordelijkheden',
            description: 'Bepaal wie maatregelen uitvoert en goedkeurt via de RACI-matrix.',
            href: '/organisatie/verantwoordelijkheden',
            icon: ClipboardCheck,
          },
          {
            title: 'Nodig een gebruiker uit',
            description: 'Geef een collega toegang tot de Spooker-omgeving.',
            href: '/organisatie/gegevens',
            icon: UserPlus,
          },
        ]}
        overviewHref="/organisatie/gegevens"
        overviewLabel="Bekijk alle organisatie-instellingen"
        testId="organisatie-home"
      />
    </MainLayout>
  );
};

export default OrganisatieHomePage;
